import React, { useState } from "react";
import Header from "../../components/Header/Header";
import HeroBanner from "../../components/HeroBanner/HeroBanner";
import CategoryNav from "../../components/CategoryNav/CategoryNav";
import GamesGrid from "../../components/GamesGrid/GamesGrid";
import ProviderSection from "../../components/ProviderSection/ProviderSection";
import SuperBonusCard from "../../components/SuperBonusCard/SuperBonusCard";
import EventSection from "../../components/EventSection/EventSection";
import FeaturedGames from "../../components/FeaturedGames/FeaturedGames";
import FooterLinks from "../../components/FooterLinks/FooterLinks";
import SponsorshipSection from "../../components/SponsorshipSection/SponsorshipSection";
import BrandAmbassadors from "../../components/BrandAmbassadors/BrandAmbassadors";
import OfficialPartners from "../../components/OfficialPartners/OfficialPartners";
import GamingLicense from "../../components/GamingLicense/GamingLicense";
import ResponsibleGaming from "../../components/ResponsibleGaming/ResponsibleGaming";
import SocialMedia from "../../components/SocialMedia/SocialMedia";
import AboutSection from "../../components/AboutSection/AboutSection";
import BottomNav from "../../components/BottomNav/BottomNav";
import Banner from "../../components/Banner/Banner";
import "./Home.css";
import MatchSlider from "../MatchSlider";
import Announcement from "../../common/Announcement";
import NoticePanel from "../../components/NoticePanel/NoticePanel";
import LoginModal from "../../components/LoginModal/LoginModal";
import RegisterModal from "../../components/RegisterModal/RegisterModal";

const Home = ({ globalData, userData, featuredGames }) => {

  const [showModal, setShowModal] = useState(false);
    const [open, setOpen] = useState(false); 
  return (
    <div className="home-container">
      <Header userData={userData} />
      <main className="main-content">
        <HeroBanner slidersMain={globalData.sliders?.main || []} />
        <Announcement globalData={globalData} />
        {/* <NoticePanel /> */}
        <NoticePanel
        
          globalData={globalData}
          onLogin={() => setShowModal(true)}
          onRegister={() => setOpen(true)}
        />

        <LoginModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onLogin={(data) => console.log("login data:", data)}
          onRegister={() => console.log("register")}
          onForgotPassword={() => console.log("forgot password")}
        />
        <RegisterModal
          isOpen={open}
          onRegister={(data) => console.log("login data:", data)}
          onClose={() => setOpen(false)}
          // onLogin={() => console.log("go to login")}
        />
        <CategoryNav
          marketBlock={globalData.marketBlock || []}
          featuredGames={globalData.sliders?.feature || []}
        />


        <FooterLinks />
        {/* <SponsorshipSection /> */}
        {/* <BrandAmbassadors /> */}
        {/* <OfficialPartners />
        <GamingLicense />
        <ResponsibleGaming />
        <SocialMedia /> */}
        {/* <AboutSection /> */}
      </main>
      <BottomNav />
    </div>
  );
};

export default Home;
